import React, { useEffect, useState } from "react";
import { Languages } from "lucide-react";

const GOOGLE_TRANSLATE_ID = "google_translate_element";

function setTranslateCookie(lang) {
  const value = lang === "en" ? "/en/en" : `/en/${lang}`;
  document.cookie = `googtrans=${value};path=/`;
  document.cookie = `googtrans=${value};path=/;domain=${window.location.hostname}`;
}

function selectLanguage(lang) {
  const combo = document.querySelector(".goog-te-combo");
  if (combo) {
    combo.value = lang;
    combo.dispatchEvent(new Event("change"));
  }
}

export default function LanguageSwitcher() {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (!window.google?.translate?.TranslateElement) return;
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,hi,ur",
          autoDisplay: false,
        },
        GOOGLE_TRANSLATE_ID
      );
    };

    if (!document.querySelector('script[src*="translate_a/element.js"]')) {
      const script = document.createElement("script");
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    setTranslateCookie(lang);
    selectLanguage(lang);
    setTimeout(() => selectLanguage(lang), 600);
  };

  return (
    <div className="notranslate flex items-center gap-1 rounded-full border border-brand-primary/15 bg-white/75 p-1">
      <div id={GOOGLE_TRANSLATE_ID} className="hidden" />
      <Languages className="w-4 h-4 text-brand-primary ml-2" />
      {[
        ["en", "EN"],
        ["hi", "HI"],
        ["ur", "UR"],
      ].map(([code, label]) => (
        <button
          key={code}
          type="button"
          onClick={() => changeLanguage(code)}
          className={`px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${
            language === code
              ? "bg-brand-primary text-white"
              : "text-brand-primary hover:bg-brand-accent"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
